import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import SiteLayout from "@/components/SiteLayout";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * Wraps a portal page component with:
 *  - SiteLayout (branch=continuum)
 *  - Access gate (redirects to /portal/continuum locked view if user lacks continuum access)
 */
export default function PortalPageWrapper({ children }) {
  const { user } = useAuth();
  const [access, setAccess] = useState(null);

  useEffect(() => {
    if (user && user !== false) {
      api.get("/me/access")
        .then(({ data }) => setAccess(data))
        .catch(() => setAccess({ continuum: false }));
    }
  }, [user]);

  if (user === false) return <Navigate to="/login?redirect=/portal/continuum" replace />;
  if (user === null || access === null) {
    return (
      <SiteLayout branch="continuum">
        <div className="section text-center text-[var(--muted)]">Loading…</div>
      </SiteLayout>
    );
  }
  if (!access.continuum) return <Navigate to="/portal/continuum" replace />;

  return <SiteLayout branch="continuum">{children}</SiteLayout>;
}
